import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import BufferOptionsItem from 'buffers/BufferOptionsItem';
import {SimplifiedCircularSequenceOptionsProps} from 'molbio/maps/options/CircularSequenceOptionsView';
import HiddenAnnotationsWarningBadge from 'molbio/maps/options/HiddenAnnotationsWarningBadge';
import MapSelector from 'molbio/maps/options/MapSelector';
import {PanSlider, ZoomSlider} from 'molbio/maps/options/Sliders';
import {shouldShowHiddenAnnotationsWarning} from 'molbio/maps/options/utils';
import DisplayOptions from 'settings/visibility-options/DisplayOptions';

export default function SimplifiedCircularOptions({
  mapType,
  onSelectMapType,
  isCircular,
  visibilityOptions,
  featureCounts,
  panSliderProps,
  zoomSliderProps,
  shownAnnotationsCount,
  visibleAnnotationsCount,
}: SimplifiedCircularSequenceOptionsProps): JSX.Element {
  return (
    <div className="buffer-options-container">
      <BufferOptionsItem>
        <MapSelector mapType={mapType} onSelectMapType={onSelectMapType} isCircular={isCircular} />
      </BufferOptionsItem>
      <BufferOptionsItem>
        <ZoomSlider {...zoomSliderProps} />
      </BufferOptionsItem>
      <BufferOptionsItem>
        <PanSlider {...panSliderProps} />
      </BufferOptionsItem>
      {shouldShowHiddenAnnotationsWarning({
        shownAnnotationsCount,
        visibleAnnotationsCount,
      }) && <HiddenAnnotationsWarningBadge />}
      <BufferOptionsItem className={css(styles.expander)} />
      <BufferOptionsItem className="u-vertical-center-items">
        <DisplayOptions dropLeft={true} options={visibilityOptions} featureCounts={featureCounts} />
      </BufferOptionsItem>
    </div>
  );
}

const styles = StyleSheet.create({
  expander: {
    // Normally the banner has a flex value so it expands and pushes the DisplayOptions and SearchButton
    // all the way to the right.
    flex: 1,
  },
});
